<template>
  <div class="bodys">
    <conditional-search @onSearch="Search"> </conditional-search>
    <div class="content">
      <div class="head">
        <table class="From" v-if="check.nav == 0">
          <el-table :data="listData" style="width: 100%">
            <el-table-column prop="school_id" label="院校代码">
            </el-table-column>
            <el-table-column prop="name" label="院校名称" width="200">
            </el-table-column>
            <el-table-column prop="specialty_name" label="专业名称" width="200">
            </el-table-column>
            <el-table-column prop="order_rule" label="录取规则" width="200">
            </el-table-column>
            <el-table-column prop="w_scale" label="文化占比" width="80">
            </el-table-column>
            <el-table-column prop="z_scale" label="专业占比" width="80">
            </el-table-column>
            <el-table-column prop="recruitment_num" label="实际投档" width="80">
            </el-table-column>
            <el-table-column prop="plan_num" label="专业计划">
            </el-table-column>
            <el-table-column prop="min_score" label="最低分" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="year" label="年份" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="pici" label="批次" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </table>
        <div v-else>
          <table class="From" v-if="check.state == 0">
            <el-table :data="listData" style="width: 100%">
              <el-table-column prop="school_id" label="院校代码">
              </el-table-column>
              <el-table-column prop="name" label="院校名称" width="310">
              </el-table-column>
              <el-table-column prop="specialty_name" label="专业名称" width="260" v-if="check.type != 2 && check.type != 3">
              </el-table-column>
              <el-table-column prop="plan_num" label="专业计划">
              </el-table-column>
              <el-table-column prop="max_score" label="最高分" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="mean_score" label="平均分" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="min_score" label="最低分" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="ranking" label="最低分位次" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="year" label="年份" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </table>

          <table class="From" v-if="check.state == 1">
            <el-table :data="listData" style="width: 100%">
              <el-table-column prop="school_id" label="院校代码">
              </el-table-column>
              <el-table-column prop="name" label="院校名称" width="200">
              </el-table-column>
              <el-table-column prop="plan_num" label="专业计划">
              </el-table-column>
              <el-table-column prop="sex" label="性别" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="min_score" label="最低分" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="ranking" label="最低分位次" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </table>
        </div>

      </div>
    </div>
    <!--        分页-->
    <div class="pagination">
      <el-pagination :hide-on-single-page="true" :page-size="page.pageSize" :current-page="page.pageNum"
        :pager-count="11" :total="page.total" class="page-box" layout="prev, pager, next"
        @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
import ConditionalSearch from './components/ConditionalSearch.vue';
export default {
  props: ['userInfo'],
  components: { ConditionalSearch },
  name: '',
  data() {
    return {
      listData: [],
      page: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      specialtyNameList: [4, 5, 6, 7, 8],
      count: 1,
      check: {
        type: 2,
        state: 0,
        nav: 1
      },
    };
  },

  computed: {
  },

  created() {
    this.getData()
  },
  methods: {
    getData() {
      let wenli = 1
      if (this.userInfo.subject == 4) {
        wenli = 1
      } else {
        wenli = 2
      }
      if (this.check.state == 1) {
        this.$fecth
          .post("specialty_score/get_specialty_score_other_m", {
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
            is_wenli: wenli,
            type: this.check.type
          })
          .then(res => {
            console.log(res)
            this.listData = res.data.list
            this.page.total = res.data.count
          });
      } else {
        if (this.check.nav == 1 || this.check.nav == 2) {
          this.$fecth
            .post("specialty_score/get_specialty_score_other", {
              pageNum: this.page.pageNum,
              pageSize: this.page.pageSize,
              is_wenli: wenli,
              type: this.check.type
            })
            .then(res => {
              console.log(res)
              this.listData = res.data.list
              this.page.total = res.data.count
            });
        } else {
          this.$fecth
            .post("specialty_score/get_specialty_score_other_art", {
              pageNum: this.page.pageNum,
              pageSize: this.page.pageSize,
              is_wenli: wenli,
              type: this.check.type
            })
            .then(res => {
              console.log(res)
              this.listData = res.data.list
              this.page.total = res.data.ElPaginationcount
            });
        }

      }

    },
    Search(item) {
      this.check = item
      console.log(this.check)
      this.page.pageNum = 1
      this.getData()
    },
    pageChange(page) {
      document.body.scrollTop = document.documentElement.scrollTop = 450
      this.page.pageNum = page
      this.getData()
    }
  },
};
</script>

<style scoped lang='less'>
.bodys {
  width: 1100px;
  margin: 20px auto;
  padding: 20px 40px;
}

.From {
  font-size: 16px;
  width: 800px;

  border-collapse: collapse;
  margin-top: 40px;

  thead tr td {
    text-align: center;
    padding: 10px 30px;
    border: 1px solid #dfdfdf;
  }

  .head_title {
    background: #ebeef5;
    color: #519deb;
  }

  .test {
    word-wrap: break-word;
    word-break: break-all;
  }

  tbody td {
    padding: 10px 30px;
    text-align: center;
    border: 1px solid #dfdfdf;
  }

  .school {
    background: #ebeef5;
  }

  .toSchool a {
    color: #349dff;
  }
}

//分页
.pagination {
  padding: 40px 0;

  .page-box {
    text-align: center;
  }
}
</style>
